import { ApiService } from "Services/ApiService";
import {
  ChangePasswordRequestDTO,
  ChangePasswordResponse,
  ResultsDTO
} from "Types";


export const changePasswordApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    changePassword: builder.mutation<ResultsDTO, ChangePasswordRequestDTO>({
      query: (data) => ({
        url: "user-settings/change-password",
        method: "PUT",
        body: data,
      }),
    }),
  }),
});

export const { useChangePasswordMutation } = changePasswordApiSlice;
